module.exports = __webpack_public_path__ + "img/MED_NUTS@300x.54fd0c4f.png";